import { request } from "./api";

export type ArchiveFile = {
  id: string;
  kind: string;
  version: number;
  file_name: string;
  status: string;
  state: "pending" | "sent" | "failed";
  attempts: number;
  error: string | null;
  size: number;
  producer: string;
  chapter: string | null;
  has_message: boolean;
  created_at: string | null;
  sent_at: string | null;
};

export type ArchiveJob = {
  id: string;
  state: "building" | "uploading" | "done" | "failed";
  progress: string;
  parts_done: number;
  parts_total: number;
  counts: Record<string, number> | null;
  size: number;
  file_name: string | null;
  error: string | null;
  include_drafts: boolean;
  finished_at: string | null;
};

export type ArchiveStatus = {
  enabled: boolean;
  files: { sent: number; pending: number; failed: number };
  recent: ArchiveFile[];
  job: ArchiveJob | null;
};

export type ArchivePreview = {
  enabled: boolean;
  has_approved: boolean;
  files: Record<string, number>;
  origins?: Record<string, Record<string, number>>;
  total_files: number;
  estimated_bytes: number;
  parts: number;
  split: boolean;
  destination: string;
  error: string | null;
  previous: { at: string | null; file: string | null; parts: number } | null;
  include_drafts: boolean;
};

export const courseArchiveApi = {
  status: (token: string, courseId: string) => request<ArchiveStatus>(`/admin/courses/${courseId}/archive/status`, {}, token),
  retry: (token: string, fileId: string) => request<ArchiveFile>(`/admin/archive/files/${fileId}/retry`, { method: "POST" }, token),
  preview: (token: string, courseId: string, includeDrafts: boolean) =>
    request<ArchivePreview>(`/admin/courses/${courseId}/archive/preview`, { method: "POST", body: JSON.stringify({ include_drafts: includeDrafts }) }, token),
  start: (token: string, courseId: string, includeDrafts: boolean) =>
    request<ArchiveJob>(`/admin/courses/${courseId}/archive/zip`, { method: "POST", body: JSON.stringify({ include_drafts: includeDrafts, confirm: true }) }, token),
  job: (token: string, courseId: string, jobId: string) => request<ArchiveJob>(`/admin/courses/${courseId}/archive/jobs/${jobId}`, {}, token),
};
